module.exports = __webpack_public_path__ + "assets/img/2478.7e9fdd8d.png";